import { observer } from "mobx-react";
import React from "react";
import { useTranslation } from "react-i18next";

import { AccountActivityReviewReportDto } from "@api-types/reports/ReportResultDto";
import { useAccountStatementStore } from "@state/hooks/account-statement/useAccountStatementStore";
import AccountStatementPaymentTableItem from "./AccountStatementPaymentTableItem";

export default observer(function AccountStatementPaymentTable() {
	const t = useTranslation().t;
	const store = useAccountStatementStore();

	if (
		!store.bettingAndPaymentTableData ||
		!store.bettingAndPaymentTableData.userActivity?.length
	) {
		return null;
	}

	return (
		<>
			<thead className="table__head table__head--accent">
				<tr className="table__head__row table__row">
					<th
						className="table__head__cell table__cell table__cell--sml u-type--center"
						colSpan={6}
					>
						{t<string>("ACC_STATEMENT.TABLES.TABLE_PAYMENT")}
					</th>
				</tr>
			</thead>
			<tbody className="table__body">
				<tr className="table__body__tr table__row">
					<td className="table__body__cell table__cell table__cell--sml table__cell--icon-only">
						&nbsp;
					</td>
					<td className="table__body__cell table__cell table__cell--sml u-type--wgt--medium">
						{t<string>("ACC_STATEMENT.TABLES.NUMBER_TRANSACTIONS")}
					</td>
					<td className="table__body__cell table__cell table__cell--sml u-type--right u-type--wgt--medium">
						{t<string>("ACC_STATEMENT.TABLES.TABLE_DEPOSIT")}
					</td>
					<td className="table__body__cell table__cell table__cell--sml u-type--right u-type--wgt--medium">
						{t<string>("ACC_STATEMENT.TABLES.TABLE_WITHDRAWAL")}
					</td>
					<td className="table__body__cell table__cell table__cell--sml u-type--right u-type--wgt--medium">
						{t<string>("ACC_STATEMENT.TABLES.TABLE_GAIN")}
					</td>
					<td className="table__body__cell table__cell table__cell--sml u-type--right u-type--wgt--medium">
						{t<string>("ACC_STATEMENT.TABLES.TABLE_LOSS")}
					</td>
				</tr>
				{store.bettingAndPaymentTableData.userActivity.map(
					(item: AccountActivityReviewReportDto, index: number) => (
						<AccountStatementPaymentTableItem
							tableItem={item}
							key={index}
						/>
					)
				)}
			</tbody>
		</>
	);
});
